@if (isLoading) {
  <ui-loading-spinner></ui-loading-spinner>
} @else {
  <div class="in-progress-cards">
    @for (incasso of incassi; track incasso.id) {
      <button type="button" class="in-progress-card" (click)="apriIncasso(incasso)">
        <div class="in-progress-card-content">
          <span class="body-medium-emphasized">{{ incasso.cliente }}</span>
          <span class="body-medium">{{ 'receipts.ui.dataInc' | transloco: { value0: (incasso.dataIncasso) } }}</span>

          <div class="in-progress-card-footer">
            <span class="body-medium">{{ 'receipts.ui.zona3' | transloco: { value0: (incasso.zona) } }}</span>
            <span class="body-medium in-progress-status-badge">{{ incasso.situazione }}</span>
          </div>
        </div>

        <span class="in-progress-card-action" aria-hidden="true">
          <i class="fa-regular fa-chevron-right"></i>
        </span>
      </button>
    } @empty {
      <span class="title-small">{{ 'receipts.ui.nessunIncassoInLavorazione' | transloco }}</span>
    }
  </div>

  <ui-table-view
    class="in-progress-table"
    [columnsInfo]="columns"
    [data]="incassi"
    (rowClicked)="apriIncasso($event)"
  />

  <mat-paginator
    class="in-progress-paginator"
    [length]="totalItems"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    [pageSizeOptions]="[5, 10, 25]"
    [hidePageSize]="true"
    (page)="onPageChange($event)"
  >
  </mat-paginator>
}
